import axios from 'axios';
import { useQuery } from 'react-query';
import {
	Category,
	CategoryGroups,
	OutboxStats,
	ShopTopics,
	ShopTopicState,
	TelegramBindStatus,
	ManagerBotStatus,
	TelegramTagTopics,
} from '../model';

const TELEGRAM = `/api/admin/telegram`;

export const TELEGRAM_BIND_KEY = 'telegram-bind';
export const MANAGER_STATUS_KEY = 'telegram-manager-status';

export const useGetTelegramBind = () => {
	return useQuery<TelegramBindStatus>(
		[TELEGRAM_BIND_KEY],
		async () => {
			const { data } = await axios.get(`${TELEGRAM}/bind`);
			return data;
		},
		{
			refetchOnWindowFocus: false,
			// Очередь разбирает cron раз в минуту — чаще обновлять смысла нет
			refetchInterval: 30000,
		}
	);
};

export const TELEGRAM_TAG_TOPICS_KEY = 'telegram-tag-topics';

/**
 * Темы тегов в группе новостей. Создаются сами при первой публикации, поэтому
 * список только читаем — и подтягиваем заново, когда тема могла появиться.
 */
export const useGetTelegramTagTopics = (enabled = true) => {
	return useQuery<TelegramTagTopics>(
		[TELEGRAM_TAG_TOPICS_KEY],
		async () => {
			const { data } = await axios.get(`${TELEGRAM}/tag-topics`);
			return data;
		},
		{ refetchOnWindowFocus: false, refetchInterval: 30000, enabled }
	);
};

export const TELEGRAM_CATEGORY_GROUPS_KEY = 'telegram-category-groups';
export const TELEGRAM_SHOP_TOPICS_KEY = 'telegram-shop-topics';
export const TELEGRAM_OUTBOX_KEY = 'telegram-outbox';
export const CATEGORIES_KEY = 'telegram-categories';

export const useGetCategoryGroups = () => {
	return useQuery<CategoryGroups>(
		[TELEGRAM_CATEGORY_GROUPS_KEY],
		async () => {
			const { data } = await axios.get(`${TELEGRAM}/categories`);
			return data;
		},
		{ refetchOnWindowFocus: false }
	);
};

export const useGetShopTopics = (filter?: {
	categoryId?: number;
	state?: ShopTopicState;
	botInGroup?: boolean;
}) => {
	return useQuery<ShopTopics>(
		[TELEGRAM_SHOP_TOPICS_KEY, filter],
		async () => {
			const { data } = await axios.get(`${TELEGRAM}/shop-topics`, {
				params: {
					categoryId: filter?.categoryId,
					state: filter?.state,
					botInGroup: filter?.botInGroup,
					limit: 200,
				},
			});
			return data;
		},
		{
			refetchOnWindowFocus: false,
			// Оператор добавляет ботов в группы руками — статус меняется
			// без его участия, поэтому список подтягиваем сам
			refetchInterval: 30000,
		}
	);
};

export const useGetOutboxStats = () => {
	return useQuery<OutboxStats>(
		[TELEGRAM_OUTBOX_KEY],
		async () => {
			const { data } = await axios.get(`${TELEGRAM}/outbox`);
			return data;
		},
		{ refetchOnWindowFocus: false, refetchInterval: 30000 }
	);
};

/** Категории тянем из публичного справочника — там же, где их заводят. */
export const useGetCategories = () => {
	return useQuery<{ categories: Category[] }>(
		[CATEGORIES_KEY],
		async () => {
			const { data } = await axios.get(`/api/categories/`);
			return data;
		},
		{ refetchOnWindowFocus: false }
	);
};

/** Состояние бота-манагера: чинит его только оператор, отсюда и место. */
export const useGetManagerStatus = () => {
	return useQuery<ManagerBotStatus>(
		[MANAGER_STATUS_KEY],
		async () => {
			const { data } = await axios.get(`${TELEGRAM}/manager-status`);
			return data;
		},
		{ refetchOnWindowFocus: false, refetchInterval: 60000 }
	);
};
